export const contentTableConfig = {
  title: '客户列表',
  propList: [
    {prop: 'uname', label: '客户昵称', minWidth: '80', align: 'left', slotName: 'consumer'},
    {prop: 'unionId', label: '客户UnionId', minWidth: '100', align: 'left'},
    {prop: 'userId', label: '工作微信号', minWidth: '80', align: 'left'},
    {prop: 'corpName', label: '所属主体', minWidth: '80', align: 'left'},
    {prop: 'sourceLabel', label: '来源渠道', minWidth: '80', align: 'left'},
    {prop: 'thirdParty', label: '所属第三方', minWidth: '50', align: 'left'},
    {prop: 'createdAt', label: '加入时间', minWidth: '80', sortable: true},
    {prop: 'deletedAt', label: '删除时间', minWidth: '80', sortable: true}
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
